import React from 'react';
import './Education.css';
import portfolioData from '../data/portfolio.json';

const Education = () => {
  const { education } = portfolioData;

  return (
    <section id="education" className="education">
      <h2>Education</h2>
      <div className="education-grid">
        {education.map((edu, index) => (
          <div key={index} className="education-card">
            <div className="edu-icon">🎓</div>
            <div className="edu-content">
              <h3 className="edu-degree">{edu.degree}</h3>
              <p className="edu-institution">{edu.institution}</p>
              <div className="edu-details">
                {edu.year && <span className="edu-year">Year: {edu.year}</span>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Education;
